import React from 'react';
import { Link } from 'react-router-dom';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';

class LzToolbar extends React.Component {

    renderItem(item, defaultIsButtons, clickCallback) {
        const isButton = item.type ? 'buttons' === item.type : defaultIsButtons;

        if (isButton) {
            return <Button
                className={'lz-button-' + (item.color || '')}
                variant={item.variant || 'text'}
                onClick={clickCallback}
                startIcon={item.icon}
            >{item.label}</Button>;
        }

        return <Tooltip title={item.label}>
            <IconButton
                className={'lz-icon-button-' + (item.color || '')}
                onClick={clickCallback}
            >{item.icon}</IconButton>
        </Tooltip>;
    }

    render() {
        const { items, icons, highlighted, buttons, otherStack } = this.props;

        if (!items || items.length < 1) {
            return '';
        }

        const defaultIsButtons = buttons || !icons;

        return (
            <Toolbar className={'lz-toolbar' + (highlighted ? ' highlighted' : '')}>

                {otherStack &&
                    <div className="lz-other-stack">{otherStack}</div>
                }

                {items.map((item, dex) =>

                    <React.Fragment key={'item-' + dex}>

                        {typeof item.onClick === 'function' ?
                            this.renderItem(item, defaultIsButtons, item.onClick)
                            :
                            <Link to={item.route || '/'}>{this.renderItem(item, defaultIsButtons, null)}</Link>
                        }

                    </React.Fragment>

                )}

            </Toolbar>
        );
    }

}

export default LzToolbar;
